import { SOURCE_TYPE } from './api/define';

export default {
    /**
     * 神奇的逻辑
     * @param contractType
     * @param customerSource
     * @returns
     */
    signTypeGenerate(contractType: number, customerSource: SOURCE_TYPE): number {
        const signList: number[] = [1, 3, 4, 5, 6];
        let signType: number = -1;
        if (signList.includes(contractType)) {
            signType = 1;
        } else if (contractType === 2) {
            signType = 2;
        } else if (contractType === 0) {
            if (customerSource === 1) {
                signType = 1;
            } else {
                signType = 2;
            }
        }
        return signType;
    },
};
